import { inject, Injectable } from "@angular/core"
import { EnvironmentService } from "./environment.service";
import { DataService } from "./data.service";
import { HttpHeaders } from "@angular/common/http";

export interface VIResponseModel<T> {
  Header: {
      OrderNumber: string;
      TimeStamp: string;
  };
  ResponseHeader: {
      ProductResponse: T[];
      WirelessResponse: T;
  };
}

export interface VIAccountResponse {
  Type: string;
  Code: number;
  Message: string;
  Lines: {
      Line: {
          Device: {
              DeviceMake: string;
              DeviceModel: string;
              DeviceIMEI: string;
              DeviceIMEIType: string;
              DeviceSIM: string;
              DeviceType: string;
              DeviceEquipmentType: string;
              DeviceTechnologyType: string;
              UpgradeEligibilityFlag: string;
              UpgradeEligibilityMessage: string;
              UpgradePayUpAmount: string;
              UpgradePayOffAmount: string;
              PromoPayUpPercentage: string;
              PromoPayUpAmount: string;
              CurrentPayPlanCode: string;
              DownPaymentPercent: string;
          };
          Number: string;
          Tn: string;
          TnType: string;
          StartDate: string;
          ContractTerm: string;
          DataPlanType: string;
          DataPlanSingleUserCode: string;
          DataPlanCode: string;
          DataPlanChoiceCode: string;
          DataPlanName: string;
          DataPlanAccessCode: string;
          DataPlanAccessTier: string;
          DataPlanGroupID: string;
          DataPlanPrimarySubscriber: string;
          DataPlanFee: string;
          IsUYW: string;
          IsCompleteConnect: string;
          DataPlanInsuranceCode: string;
          DataPlanInsuranceName: string;
      };
  };
  SubType: string;
  AccountNumber: string;
  AccountStatus: string;
  AccountType: string;
  AccountName: string;
  Fan: string;
  AccountCreationDate: string;
  LineCount: string;
  FirstName: string;
  LastName: string;
  PhoneNumber: string;
  EmailAddress: string;
  BillAddressLine1: string;
  BillAddressLine2: string;
  BillCity: string;
  BillState: string;
  BillZip: string;
  DataPlanType: string;
  DataPlanSingleUserCode: string;
  DataPlanCode: string;
  DataPlanAccessCode: string;
  HasMDPP: string;
  DataPlanName: string;
  DataPlanMRC: string;
  DataPlanMaxLines: string;
  DataPlanDataGroupID: string;
  DataPlanAddtlLineFee: string;
  DataPlanActFee: string;
  FdeActionRequired: boolean | null;
  FdeCode: string | null;
  FdeMessage: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class WirelessSetupService {

  #dataService = inject(DataService)
  #environmentService = inject(EnvironmentService)
  #getAuthDataUrl = this.#environmentService.getUrl('securedata/authgetdata')
  #getAccountUrl = this.#environmentService.getUrl('securedata/authgetaccount')
  #getSendPinUrl = this.#environmentService.getUrl('securedata/authsendpin')
  #getAuthCheckFanUrl = this.#environmentService.getUrl('securedata/authcheckfan')

  private getStandardHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json');
  }


  getAuthData(req, wirelesspayload) {

    //const sessionId = this.getSessionId()
    const endpoint = this.#getAuthDataUrl
    const payload = wirelesspayload;

    payload.CustomizationInfo = {
      Category: "Wireless",
      Details: req
    }

    return this.#dataService.post<unknown, unknown>(endpoint, payload, this.getStandardHeaders())
  }

  getAccount(req, wirelesspayload) {

    const endpoint = this.#getAccountUrl;
    const payload = wirelesspayload;
    payload.CustomizationInfo = {
      Category: "Wireless",
      Details: req
    }

    return this.#dataService.post<unknown, unknown>(endpoint, payload, this.getStandardHeaders())
  }


  sendPin(req, wirelesspayload) {
    const endpoint = this.#getSendPinUrl;
    const payload = wirelesspayload;
    payload.CustomizationInfo = {
      Category: "Wireless",
      Details: req
    }
    return this.#dataService.post<unknown, unknown>(endpoint, payload, this.getStandardHeaders());
  }

  authCheckFan(req, wirelesspayload) {

    const endpoint = `${this.#getAuthCheckFanUrl}`;
    const payload = wirelesspayload;
    payload.CustomizationInfo = {
      Category: "Wireless",
      Details: req
    }

    return this.#dataService.post<unknown, unknown>(endpoint, payload, this.getStandardHeaders());
  }

}